import * as React from "react"

interface State {
    productSearchValue: string | null
    productSearchIsActive: boolean
}

export interface UiContextInterface {
    productSearchValue: string | null
    productSearchIsActive: boolean
    setProductSearchValue: (value: string) => void
    setProductSearchIsActive: (isActive: boolean) => void
}

interface Props {}

export const UiContext = React.createContext<UiContextInterface | null>(null)

class UiProvider extends React.PureComponent<Props, State> {
    state = {
        productSearchValue: "",
        productSearchIsActive: false,
    }

    setProductSearchValue = (value: string) => {
        this.setState({ productSearchValue: value })
    }

    setProductSearchIsActive = (isActive: boolean) => {
        this.setState({
            productSearchIsActive: isActive,
            productSearchValue: !isActive ? "" : this.state.productSearchValue,
        })
    }

    render = () => (
        <UiContext.Provider
            value={{
                productSearchValue: this.state.productSearchValue,
                productSearchIsActive: this.state.productSearchIsActive,
                setProductSearchValue: this.setProductSearchValue,
                setProductSearchIsActive: this.setProductSearchIsActive,
            }}>
            {this.props.children}
        </UiContext.Provider>
    )
}

const LayoutConsumer = UiContext.Consumer

export { LayoutConsumer, UiProvider }
